import AboutPageContent from '@/components/pages/about-page';

export default function AboutPage() {
  return <AboutPageContent />;
}
